var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"soldPage"},[_vm._l((_vm.soldListings),function(listing,i){return _c('Slider',{key:listing.id,attrs:{"index":i + 2,"listing":listing,"sold":"","reverse":i % 2}})}),_c('Contact')],2)}
var staticRenderFns = []

export { render, staticRenderFns }